import { toast, Toast } from "react-hot-toast";

import { IconToast } from "./IconToast";

const baseToastStyle = {
    borderRadius: 0,
    borderLeft: "5px solid"
};

const toastContent = (toastItem: Toast, message: string) =>
    IconToast({
        toastItem,
        message
    });

export const useNotifications = () => {
    const success = (message: string) => {
        toast((toastItem) => toastContent(toastItem, message), {
            style: {
                ...baseToastStyle,
                borderLeftColor: "#4BB543"
            }
        });
    };

    const error = (message: string) => {
        toast((toastItem) => toastContent(toastItem, message), {
            style: {
                ...baseToastStyle,
                borderLeftColor: "#FF0000"
            }
        });
    };

    const warning = (message: string) => {
        toast((toastItem) => toastContent(toastItem, message), {
            style: {
                ...baseToastStyle,
                borderLeftColor: "#EED202"
            }
        });
    };

    return { error, success, warning };
};
